<form [formGroup]="form" autocomplete="off" class="form-horizontal">
    <div class="mb-3x pr-2">
        <div class="form-check">
            <input class="form-check-input" datevMessagePath="eigenerWebshop{{objectId}}"
                   formControlName="eigenerWebshop"
                   id="eigenerWebshop"
                   type="checkbox" utilsCheckValidity
                   utilsControlState utilsValidationMessage>
            <label class="form-check-label"
                   for="eigenerWebshop">{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.EIGENER_WEBSHOP' | translate }}
            </label>
        </div>

        <div *ngIf="data.eigenerWebshop" class="form-row mt-1x">
            <label class="col-sm-3 col-form-label offset-sm-1"
                   for="eigenerWebshopUrl">{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.EIGENER_WEBSHOP_URL' | translate }}</label>
            <div class="col-sm-8">
                <input class="form-control" datevMessagePath="eigenerWebshopUrl{{objectId}}" formControlName="eigenerWebshopUrl"
                       id="eigenerWebshopUrl"
                       type="text" utilsCheckValidity
                       utilsControlState utilsValidationMessage/>
            </div>
        </div>

        <div class="form-check">
            <input
                    type="checkbox"
                    class="form-check-input"
                    id="handelMarktplatz"
                    formControlName="handelMarktplatz"
                    datevMessagePath="handelMarktplatz{{objectId}}"
                    utilsCheckValidity utilsControlState utilsValidationMessage
                    (ngModelChange)="clearElektronischeSchnitstelle($event)">
            <label class="form-check-label"
                   for="handelMarktplatz">{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.HANDEL_MARKTPLATZ' | translate }}
            </label>
        </div>
    </div>

    <div *ngIf="data?.handelMarktplatz">
        <h4
                class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.MARKTPLAETZE.TITEL' | translate }}
        </h4>

        <div *ngIf="data?.marktplaetze.length > 0" class="form-row">
            <label class="d-none d-sm-inline col-sm-6 col-form-label">
                {{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.MARKTPLAETZE.BEZEICHNUNG' | translate }}
            </label>
            <label class="d-none d-sm-inline col-sm-6 col-form-label">
                {{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.MARKTPLAETZE.IDENTIFIKATIONSMERKMAL' | translate }}
            </label>
        </div>

        <div *ngFor="let marktplatz of data?.marktplaetze; let i=index;">
            <common-ui-marktplatz (removeMarktplatzClicked)="removeMarktplatz($event)"
                                  [data]="marktplatz" [index]="i"
                                  [readonly]="readonly"></common-ui-marktplatz>

        </div>

        <div *ngIf="!readonly && data?.marktplaetze?.length < 99" class="form-row">
            <div class="col-12 d-flex justify-content-end">
                <button (click)="addMarktplatz()" class="btn btn-light" id="addMarktplatz"
                        title="{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.ADD_MARKTPLATZ' | translate }}"
                        type="button">
                    <em class="icon icon-svg icon-fi-hinzufuegen"></em>
                    {{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.ADD_MARKTPLATZ' | translate }}
                </button>
            </div>
        </div>
    </div>
</form>
